export const epmSections = [
  { id: 'home', title: 'Home' },
  { id: 'testing-board', title: 'Testing Board' },
  { id: 'schedule', title: 'Schedule' },
  { id: 'learnings', title: 'Learnings' },
  { id: 'settings', title: 'Settings' },
];
